import { ButtonProps, DialogActionsProps, DialogProps } from '@mui/material';
import { ConfirmOptions, ConfirmProvider } from 'material-ui-confirm';
import React from 'react';

import { translate } from '@/ui/i18n';
import { ColorsRaw } from '@/ui/theme/colors-raw';

export function FSConfirmDialogProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const defaultOptions: ConfirmOptions = {
    title: '',
    description: '',
    confirmationText: translate('Form.confirm'),
    cancellationText: translate('Form.cancel'),
    dialogProps: dialogProps,
    dialogActionsProps: dialogActionsProps,
    confirmationButtonProps: confirmationButtonProps,
    cancellationButtonProps: cancellationButtonProps,
    // titleProps
    // contentProps
    allowClose: true,
  };

  return (
    <ConfirmProvider defaultOptions={defaultOptions}>
      {children}
    </ConfirmProvider>
  );
}

const dialogActionsProps: DialogActionsProps = {
  sx: {
    mb: 2,
    mx: 2,
  },
};

const dialogProps: Omit<DialogProps, 'open'> = {
  sx: {
    '& .MuiPaper-root': {
      borderRadius: '28px',
      background: ColorsRaw.anthracite.Anthracite_3,
    },
    '& .MuiTypography-root': {
      color: ColorsRaw.basic.Cream,
    },
    '& .MuiLink-root': {
      color: ColorsRaw.main.Navy_Light,
    },
  },
};

const confirmationButtonProps: ButtonProps = {
  variant: 'contained',
  color: 'secondary',
  sx: {
    borderRadius: '100px',
    textTransform: 'none',
    paddingRight: '20px',
    paddingLeft: '20px',
    fontSize: '14px',
    height: '40px',
    fontWeight: 'bold',
  },
};

const cancellationButtonProps: ButtonProps = {
  sx: {
    borderRadius: '100px',
    textTransform: 'none',
    paddingRight: '20px',
    paddingLeft: '20px',
    fontSize: '14px',
    height: '40px',
    fontWeight: 'bold',
  },
};
